import { useState } from 'react'

import { customPost } from '../utils/customFetch.ts'
import YapoInputVehicle from '../interfaces/YapoInputVehicle.ts'
import YapoPublishResult from '../interfaces/YapoPublishResult.ts'

import { makeUrlYapoDelete, makeUrlYapoPublish, makeUrlYapoSetPublished } from './connectionData.tsx'

const useYapoPublisher = () => {
  const [errorYapoPublish, setErrorYapoPublish] = useState<Error | null>(null)
  const [errorYapoDelete, setErrorYapoDelete] = useState<Error | null>(null)
  const [errorYapoSetPublished, setErrorYapoSetPublished] = useState<Error | null>(null)
  const [loading, setLoading] = useState<boolean>(false)

  const yapoPublish = async (vehicle: YapoInputVehicle) => {
    setLoading(true)

    try {
      const apiUrl = makeUrlYapoPublish()
      const res = await customPost<YapoPublishResult>(apiUrl, vehicle)

      setErrorYapoPublish(null)

      return res
    } catch (err) {
      // Assert the error as an instance of Error
      if (err instanceof Error) {
        setErrorYapoPublish(err)
      } else {
        setErrorYapoPublish(new Error('An unknown error occurred'))
      }

      return null
    } finally {
      setLoading(false)
    }
  }
  // Marca el vehiculo como yapo_publishedAt
  const yapoSetPublished = async (_id: string, by: string) => {
    setLoading(true)

    try {
      const apiUrl = makeUrlYapoSetPublished()
      await customPost(apiUrl, { _id: _id, by })

      setErrorYapoSetPublished(null)

      return 'OK'
    } catch (err) {
      // Assert the error as an instance of Error
      if (err instanceof Error) {
        setErrorYapoSetPublished(err)
      } else {
        setErrorYapoSetPublished(new Error('An unknown error occurred'))
      }

      return null
    } finally {
      setLoading(false)
    }
  }
  // Borra el aviso en yapo
  const yapoDelete = async (_id: string) => {
    setLoading(true)

    try {
      const apiUrl = makeUrlYapoDelete()
      await customPost(apiUrl, { _id: _id })

      setErrorYapoDelete(null)

      return 'OK'
    } catch (err) {
      // Assert the error as an instance of Error
      if (err instanceof Error) {
        setErrorYapoDelete(err)
      } else {
        setErrorYapoDelete(new Error('An unknown error occurred'))
      }

      return null
    } finally {
      setLoading(false)
    }
  }

  // Exponemos estas variables al exterior
  return {
    loading,
    yapoPublish,
    errorYapoPublish,
    yapoSetPublished,
    errorYapoSetPublished,
    yapoDelete,
    errorYapoDelete,
  }
}

export default useYapoPublisher
